export const HintButton = (props) => {
  return (
    <button
      type="button"
      class="button hint"
      onClick={props.onClick}
      title={props.title}
    >
      ?
    </button>
  )
}
